<template>
  <div class="table-page">
    <el-button-group>
      <el-button type="primary" @click="addUserBtn">添加用户</el-button>
    </el-button-group>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="username" label="用户名" width="180">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="180">
      </el-table-column>
      <el-table-column label="用户等级" width="180">
        <template slot-scope="scope">
          <span v-if="!scope.row.is_admin && scope.row.admin_level===0">普通用户</span>
          <span v-else-if="scope.row.is_admin && scope.row.admin_level===1">普通管理员</span>
          <span v-else>超级管理员</span>
        </template>
      </el-table-column>
      <el-table-column label="是否激活" width="180">
        <template slot-scope="scope">
          <i
            v-if="scope.row.is_active"
            class="el-icon-success"
            style="font-size: 18px; color: #409eff"
          ></i>
          <i
            v-else
            class="el-icon-error"
            style="font-size: 18px; color: #f56c6c"
          ></i>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="editUserInfo(scope.row.user_id)"
            :disabled="editDisabled(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="delUserInfo(scope.row.user_id)"
            :disabled="editDisabled(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 25px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
    };
  },
  methods: {
    handleCurrentChange(val) {
      let that = this;
      that.currentPage = val;
      that.loadUserList();
    },
    handleSizeChange(val) {
      let that = this;
      that.pageSize = val;
      that.loadUserList();
    },
    addUserBtn() {
      let that = this;
      that.$router.push({
        path: "/users/detail",
      });
    },
    delUserInfo(user_id) {
      let that = this;
      that.$confirm("此操作将永久删除该用户信息, 是否继续?", "删除用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          that.$axios
            .delete(that.host + "/api/users/admin/users", {
              data: { user_id: user_id },
            })
            .then((res) => {
              that.$message.success("删除用户信息成功");
              that.loadUserList();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    loadUserList() {
      let that = this;
      let reqUrl = that.host + "/api/users/admin/users?page=" + that.currentPage + "&page_size=" + that.pageSize;
      that.$axios
        .get(reqUrl)
        .then((res) => {
          let results = res.data.results;
          that.tableData = results.users;
          that.total = results.total_count;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    editUserInfo(user_id) {
      let that = this;
      that.$router.push({
        path: "/users/detail",
        query: {
          user_id: user_id,
        },
      });
    },
    editDisabled(userInfo) {
      if (userInfo.is_admin && userInfo.username === "admin") {
        return true;
      }
      return false;
    },
  },
  mounted() {
    let that = this;
    that.loadUserList();
  },
};
</script>

<style>
.table-page {
  padding: 0 30px 0 30px;
}
</style>
